
const blocks = document.querySelectorAll('.h1');
const colors = ['#FF2C57', '#2050A0']; 
blocks.forEach(block => {
    let words = block.innerText.split(' ');
    if (words.length >= 2) {
         if (words.length == 2) {
            const getRand = () => colors[Math.floor(Math.random() * colors.length)];
            words[0] = `<span style="color: ${getRand()}">${words[0]} </span>`;
   
            block.innerHTML = words.join(' ');
         } else{
            const getRand = () => colors[Math.floor(Math.random() * colors.length)];
            words[0] = `<span style="color: ${getRand()}">${words[0]} ${words[1]}</span>`;
    words[1] = ``;
            block.innerHTML = words.join(' ');
         }
    }
});